export const suggestedSearchTerms = [
    'Full Stack',
    'Frontend',
    'Backend',
    'Data Science',
    'Mobile',
    'QA',
    'Architect',
    'DevOps',
    'UI / UX',
    'Product Management',
]
